import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import BusinessProfileAppResource from './BusinessProfileAppResource';
import ContactAppResource from './ContactAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import PropertyAppResource from './PropertyAppResource';
import PropertyInstanceAppResource from './PropertyInstanceAppResource';
import UserAppResource from './UserAppResource';
import AgentContactAppResource from "./AgentContactAppResource";
import PropertyContactAppResource from './PropertyContactAppResource';

export const PHONE_FORMAT_ERROR_MESSAGE = 'Phone has invalid format! Valid format: (xxx) xxx-xxxx';

class PhoneAppResource extends AppResource {

    get validationPlainPresence () {
        return typeof this._validationPlainPresence === 'undefined' ? true : this._validationPlainPresence
    }

    set validationPlainPresence (value) {
        this._validationPlainPresence = value
    }
    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Phone';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'phones';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'plain',
            'users',
            'organizations',
            'properties',
            'propertyInstances',
            'businessProfiles',
            'contacts',
            'agentContacts',
            'propertyContacts',
            'phone',
            'meta',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            users: UserAppResource,
            organizations: OrganizationAppResource,
            properties: PropertyAppResource,
            propertyInstances: PropertyInstanceAppResource,
            businessProfiles: BusinessProfileAppResource,
            contacts: ContactAppResource,
            agentContacts: AgentContactAppResource,
            propertyContacts: PropertyContactAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        const rules = {
            plain: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            phone: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            meta: {},
        };

        if (this.validationPlainPresence) {
            rules.plain.presence = true
        }

        return rules;
    }

}

export default PhoneAppResource;
